import { useAppDispatch } from '@/Application/Hooks/Redux';
import giftCardLogo from '@/modules/perseo-billing/assets/images/gift-card-logo.png';
import { formatPrice, useGiftCardData } from '@/modules/perseo-billing/hooks';
import { setIsGiftCardModalRemoveOpen } from '@/modules/perseo-billing/store/slices/billing';
import {
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src/ui-hooks';

const LABEL_MASK = '**** **** **** ****';
const LABEL_APPLIED_BALANCE = 'Saldo aplicado';
const LABEL_BALANCE = 'Saldo a favor';

export const SubmittedGiftCardPreview = () => {
  const { getGiftCardAmount, getGiftCardBalance } = useGiftCardData();

  const isMobile = useMediaQuery('lg');
  const dispatch = useAppDispatch();

  const giftCardAmount = getGiftCardAmount();
  const giftCardBalance = getGiftCardBalance();

  const discountFormated = formatPrice(giftCardAmount);
  const balanceFormatted = formatPrice(giftCardBalance);

  return (
    <div
      className={`${
        isMobile ? '' : 'co-p-4 co-bg-pds-neutral-100'
      } co-flex co-rounded-lg co-gap-4 '`}
    >
      <div
        className={`${
          isMobile ? 'co-flex' : 'co-flex co-flex-col co-pt-0'
        } co-relative co-w-[283px] lg:co-h-152px co-justify-end co-h-full co-p-16px co-bg-gradient-to-tr co-from-[#1BA099] co-to-[#2FE7DD] co-rounded-8px co-font-mono co-text-pds-neutral-900 co-overflow-hidden`}
      >
        <div
          className={`${
            isMobile
              ? 'co-inline-flex co-absolute co-top-0 co-left-[15px]'
              : 'co-absolute co-top-0'
          }`}
        >
          <img
            src={giftCardLogo}
            alt={'gift-card-logo'}
            width={48}
            height={48}
          />
        </div>

        <div
          className={`${
            isMobile ? 'co-w-9/12' : ''
          } co-flex co-flex-col co-gap-2`}
        >
          <div className="co-flex co-justify-end co-self-end co-w-full">
            <Typography size={isMobile ? 'h4' : 'h3'} align="right">
              {LABEL_MASK}
            </Typography>
          </div>
          <div className="co-flex co-justify-between co-w-full co-py-1 co-px-2 co-self-end co-bg-white lg:co-w-full co-rounded-4px">
            <Typography
              lineClamp={0}
              weight="medium"
              size="body2"
              color="pds-success-700"
            >
              {LABEL_APPLIED_BALANCE}
            </Typography>
            <Typography
              lineClamp={0}
              weight="semibold"
              align="right"
              color="pds-success-700"
            >
              {discountFormated}
            </Typography>
          </div>

          {giftCardBalance ? (
            <div className="co-flex co-justify-between co-w-full co-self-end co-bg-[#00807B] co-px-2 lg:co-w-full  co-rounded-4px">
              <Typography weight="medium" size="body2" color="white">
                {LABEL_BALANCE}
              </Typography>
              <Typography weight="semibold" align="right" color="white">
                {balanceFormatted}
              </Typography>
            </div>
          ) : null}
        </div>
      </div>
      <div
        className="co-cursor-pointer co-w-20px co-h-20px"
        onClick={() => dispatch(setIsGiftCardModalRemoveOpen(true))}
      >
        <Icon icon="CloseIcon" color="black" width={20} height={20} />
      </div>
    </div>
  );
};
